import React, { useState } from "react";
import Button from "../../button/Button";
import { faCircleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import UserfulConfirmationDialog from "../UserfulConfirmationDialog";

interface IProps {}

export default function RedirectConfirmation(props: IProps) {
    const { t } = useTranslation();

    const [show, setShow] = useState(false);
    const [input, setInput] = useState<string>("");

    return (
        <>
            <UserfulConfirmationDialog
                show={show}
                icon={{ icon: faCircleExclamation, color: "#D13E2C" }}
                onCancel={() => setShow(false)}
                title={"ABC"}
                replaceBody={
                    <>
                        <p>CBD</p>
                    </>
                }
                replaceFooter={
                    <>
                        <Button variant="secondary" onClick={() => setShow(false)}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button variant="danger" onClick={() => {}}></Button>
                    </>
                }
            />
        </>
    );
}
